import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PARTNER_CLIENT_FEATURE_KEY } from '../reducer/partner-client.feature-key';
import { PartnerClientState } from '../reducer/partner-client.reducer';

const selectPartnerClientState = createFeatureSelector<PartnerClientState>(PARTNER_CLIENT_FEATURE_KEY);

export const selectPartnerClients = createSelector(selectPartnerClientState, (state) => state.clients);
export const selectPartnerClientsLoading = createSelector(selectPartnerClientState, (state) => state.loading);
export const selectPartnerClientsMutating = createSelector(selectPartnerClientState, (state) => state.mutating);
export const selectPartnerClientsError = createSelector(selectPartnerClientState, (state) => state.error);
